import React from "react";
import { NoteLog } from "../../types/post";
import {
  useLogCardActions,
  LogCardActionsProps,
} from "../../hooks/useLogCardActions";
import LogCardNotes from "../shared/NoteLogCard";
import NoteDisplay from "./NoteDisplay";

interface NoteLogCardProps
  extends LogCardActionsProps<NoteLog & { id: string }> {
  log: NoteLog & { id: string };
}

const NoteLogCard: React.FC<NoteLogCardProps> = ({ log, onDelete, onEdit }) => {
  const { handleDelete, handleEdit } = useLogCardActions(log, {
    onDelete,
    onEdit,
  });

  return (
    <NoteDisplay
      notes={log.notes}
      onDelete={onDelete ? handleDelete : undefined}
      onEdit={onEdit ? handleEdit : undefined}
    />
  );
};

export default NoteLogCard;
